import { render } from "./ForgotVerifyBySms.vue?vue&type=template&id=3ed6a6b1&scoped=true"
import script from "./ForgotVerifyBySms.vue?vue&type=script&lang=js"
export * from "./ForgotVerifyBySms.vue?vue&type=script&lang=js"

import "./ForgotVerifyBySms.vue?vue&type=style&index=0&id=3ed6a6b1&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed6a6b1"]])

export default __exports__